import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import Panel from '../../../../../../components/angle/Panel';
import { formInputValidation } from '../../../../../../services/helper/form-helper';
import EditUserForm from '../../components/UserForm';
import { fetchAccounts } from '../../../../../../services/redux/employee/account/actions';
import { fetchClientsByAccount } from '../../../../../../services/redux/employee/clientInformation/actions';
import { fetchRoles } from '../../../../../../services/redux/employee/role/actions';
import {
    editUser,
    updateEditUserPayload
} from '../../../../../../services/redux/employee/user/actions';
class EditUser extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }
    componentDidMount() {
        let { fetchAccounts, fetchRoles } = this.props;
        fetchAccounts();
        fetchRoles();
    }
    onSaveClick = () => {
        let { user, history, editUser } = this.props;
        let payload = user.editUserData;
        if (formInputValidation(this.formRef.current)) {
            editUser(payload).then(response => {
                if (response.status === 200) {
                    history.push('/sign-up');
                }
            });
        }
    };
    onCancelClick = () => {
        let { history } = this.props;
        history.push('/sign-up');
    }

    render() {
        let {
            user,
            updateEditUserPayload,
            fetchClientsByAccount,
            accounts,
            clientInformation,
            roles
        } = this.props;
        let saveButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSaveClick}
            >
                Save
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Cancel
            </button>
        );

        const buttonList = [saveButton, cancelButton];

        return (
            <div className="col-md-6 mb" style={{padding: 0}}>
                <Panel
                    showHeader
                    header="Edit User"
                    showFooter
                    footerComponents={buttonList}
                >
                    <div>
                        <EditUserForm
                            userData={user.editUserData}
                            updateUserData={updateEditUserPayload}
                            fetchAccountList={fetchClientsByAccount}
                            accountList={accounts.accounts}
                            clientList={clientInformation.clients}
                            roleList={roles.roles}
                            disableEmail={true}
                            formRef={this.formRef}
                        />
                    </div>
                </Panel>
                {accounts.fetching && <Spinner />}
                {clientInformation.fetching && <Spinner />}
                {roles.fetching && <Spinner />}
                {user.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.employee.user,
    accounts: state.employee.account,
    clientInformation: state.employee.clientInformation,
    roles: state.employee.role
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            editUser,
            updateEditUserPayload,
            fetchAccounts,
            fetchClientsByAccount,
            fetchRoles
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditUser));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SignUp/screens/EditUser/index.js